import { FC } from 'react';
import Typography from '@mui/material/Typography';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from 'further-ui/utils';
import { Row } from 'further-ui/components/Layout';
import AccountingFooter from '../components/AccountingFooter';

type GeneralLedgerTotalProps = {
  total: number;
  baseCurrency: CurrencyCode;
  isLoading: boolean;
};

const GeneralLedgerTotal: FC<GeneralLedgerTotalProps> = ({
  total,
  baseCurrency,
  isLoading,
}) => {
  const totalFormatted = numberToCurrencyString(total, {
    currency: baseCurrency,
    negativeInBrackets: true,
  });
  const showZeroTick = total === 0;

  return (
    <AccountingFooter>
      <Row justify="space-between" alignItems="center" spacing="sm">
        <Typography variant="h6" color="grey.600" lineHeight={1}>
          General ledger total
        </Typography>
        <Row alignItems="center" centered spacing="xs">
          <Typography variant={isLoading ? 'body2' : 'h6'} lineHeight={1}>
            {isLoading ? '--' : totalFormatted}
          </Typography>
          {!isLoading && showZeroTick ? <CheckCircle color="success" /> : null}
        </Row>
      </Row>
    </AccountingFooter>
  );
};

export default GeneralLedgerTotal;
